/* eslint-disable */
/*
 * @Author: wyh
 * @Date: 2020-04-20 17:21:33
 * @Last Modified by: wyh
 * @Last Modified time: 2020-04-27 13:47:40
 * @description: 自动根据页面域名获取接口域名
 */

function getEnvironInfo() {
  let environ_key = '';
  const { host, pathname } = window.location;
  /**
   * eg: m.sudasmart.com 测网、预发、灰度、正式访问地址
   * https://m-test.sudasmart.com/sd/
   * https://m.sudasmart.com/sd/pre2/index.html#/
   * https://m.sudasmart.com/sd/pre/index.html#/
   * https://m.sudasmart.com/sd/index.html#/
   * host：m.sudasmart.com
   *  */
  switch (true) {
    case host.includes('sudasmart'):
      switch (true) {
        case pathname.includes('/pre2/'):
          environ_key = 'sdPre2'; // 预发环境
          break;
        case pathname.includes('/pre/'):
          environ_key = 'sdPre'; // 灰度环境
          break;
        default:
          environ_key = 'sdProd'; // 正式环境
      }
      break;
    default:
      environ_key = 'test';
  }
  return environ_key;
}

const API_HOST = {
  test: 'djapi-daily2.yueyuechuxing.cn',
  //test: 'djapi-daily.yueyuechuxing.cn',
  sdPre2: 'api-pre2.sudasmart.com',
  sdPre: 'api-pre.sudasmart.com',
  sdProd: 'api.sudasmart.com'
};

function isTest() {
  const host = window.location.host;
  return !host || host.includes('localhost') || host.indexOf('test') !== -1 || /^[0-9.:]+$/.test(host);
}

// 返回值 带协议https:// | http://
function getApiHost() {
  const environ_key = getEnvironInfo();
  const apiHost = isTest() ? API_HOST['test'] : API_HOST[environ_key];
  const apiBaseUrl = `${window.location.protocol}//${apiHost}`;
  return apiBaseUrl;
}

export default getApiHost;
